import { render, staticRenderFns } from "./his-board.vue?vue&type=template&id=5f4f42f2&scoped=true&"
import script from "./his-board.vue?vue&type=script&lang=ts&"
export * from "./his-board.vue?vue&type=script&lang=ts&"
import style0 from "./his-board.vue?vue&type=style&index=0&id=5f4f42f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4f42f2",
  null
  
)

export default component.exports